import { z } from 'zod'

// Теги — employee-only: заказчику не приходят ни в одном view. Пишутся отдельным
// PUT /api/tags/{entity_kind}/{entity_id} с replace-семантикой ([] очищает);
// в read-view сущностей приходят как tags: string[] (имена, lower+trim).

export const TAG_MAX = 10
export const TAG_NAME_MAX = 50

export const TAG_ENTITY_KINDS = [
  'project',
  'company',
  'document',
  'task',
  'invoice',
  'meeting',
] as const
export const TagEntityKindSchema = z.enum(TAG_ENTITY_KINDS)
export type TagEntityKind = z.infer<typeof TagEntityKindSchema>

export const TagsSchema = z.array(z.string().min(1).max(TAG_NAME_MAX)).max(TAG_MAX)
export type Tags = z.infer<typeof TagsSchema>

// Подсказка автодополнения: имя + сколько сущностей его носит (ранжирование).
export const TagSuggestionSchema = z.object({
  name: z.string(),
  usage_count: z.number(),
})
export type TagSuggestion = z.infer<typeof TagSuggestionSchema>
